<div class="set-password-container">
  <div class="set-password-card">
    <div class="logo-section">
      <h1>🔐 Klemantina</h1>
      <p class="subtitle">Set Up Your Password</p>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state">
      <div class="spinner"></div>
      <p>Validating your link...</p>
    </div>

    <!-- Invalid Token State -->
    <div *ngIf="!isLoading && !isTokenValid && !isPasswordSet" class="error-state">
      <div class="error-icon">❌</div>
      <h3>Link Invalid or Expired</h3>
      <p>{{ errorMessage }}</p>
      <button class="btn-primary" (click)="goToLogin()">Go to Login</button>
    </div>

    <!-- Password Set Success State -->
    <div *ngIf="isPasswordSet" class="success-state">
      <div class="success-icon">✅</div>
      <h3>Password Set Successfully!</h3>
      <p>{{ successMessage }}</p>
      <p>You can now log in with your email and new password.</p>
      <button class="btn-primary" (click)="goToLogin()">Go to Login</button>
    </div>

    <!-- Set Password Form -->
    <form *ngIf="!isLoading && isTokenValid && !isPasswordSet" (ngSubmit)="setPassword()" class="password-form">
      <div class="email-display">
        <span class="label">Email:</span>
        <span class="email">{{ email }}</span>
      </div>

      <div class="form-group">
        <label for="password">New Password</label>
        <input 
          type="password" 
          id="password" 
          [(ngModel)]="password" 
          name="password"
          placeholder="Enter your new password"
          required
          minlength="8"
        />
        <div class="password-strength" *ngIf="password">
          <div class="strength-bar" [class]="passwordStrength"></div>
          <span class="strength-text">{{ passwordStrength | titlecase }} password</span>
        </div>
      </div>

      <div class="form-group">
        <label for="confirmPassword">Confirm Password</label>
        <input 
          type="password" 
          id="confirmPassword" 
          [(ngModel)]="confirmPassword" 
          name="confirmPassword"
          placeholder="Confirm your new password"
          required
        />
        <div class="match-indicator" *ngIf="confirmPassword">
          <span *ngIf="passwordsMatch" class="match">✓ Passwords match</span>
          <span *ngIf="!passwordsMatch" class="no-match">✗ Passwords do not match</span>
        </div>
      </div>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button 
        type="submit" 
        class="btn-primary" 
        [disabled]="isSubmitting || !password || !confirmPassword || !passwordsMatch"
      >
        <span *ngIf="!isSubmitting">Set Password</span>
        <span *ngIf="isSubmitting">Setting Password...</span>
      </button>

      <div class="password-requirements">
        <p>Password requirements:</p>
        <ul>
          <li [class.met]="hasMinLength">At least 8 characters</li>
          <li [class.met]="hasUppercase">Contains uppercase letter</li>
          <li [class.met]="hasNumber">Contains a number</li>
        </ul>
      </div>
    </form>
  </div>
</div>

